function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Ihistory = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2595 2.99958C8.16954 2.85958 3.99954 6.94958 3.99954 11.9996H2.20954C1.75954 11.9996 1.53954 12.5396 1.85954 12.8496L4.64954 15.6496C4.84954 15.8496 5.15954 15.8496 5.35954 15.6496L8.14954 12.8496C8.45954 12.5396 8.23954 11.9996 7.78954 11.9996H5.99954C5.99954 8.09958 9.17954 4.94958 13.0995 4.99958C16.8195 5.04958 19.9495 8.17958 19.9995 11.8996C20.0495 15.8096 16.8995 18.9996 12.9995 18.9996C11.3895 18.9996 9.89954 18.4496 8.71954 17.5196C8.31954 17.2096 7.75954 17.2396 7.39954 17.5996C6.97954 18.0196 7.00954 18.7296 7.47954 19.0896C8.99954 20.2896 10.9095 20.9996 12.9995 20.9996C18.0495 20.9996 22.1395 16.8296 21.9995 11.7396C21.8695 7.04958 17.9495 3.12958 13.2595 2.99958Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 8C12.34 8 12 8.34 12 8.75V12.43C12 12.78 12.19 13.11 12.49 13.29L15.61 15.14C15.97 15.35 16.43 15.23 16.64 14.88C16.85 14.52 16.73 14.06 16.38 13.85L13.5 12.14V8.74C13.5 8.34 13.16 8 12.75 8Z",
    fill: "#495057"
  }));
});